import * as actions from './eStoreCategory/actions'
import * as mutations from './eStoreCategory/mutations'
import * as getters from './eStoreCategory/getters'

import { dataProps } from './eStoreCategory/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreCategory.js